//import { Section } from './section';
import { Embedded } from './embedded';
import { Forbidden } from './forbidden/forbidden';
import { LoggedIdentity } from './loggedIdentity';
import { UniverseEnum } from './universeEnum';

export class Dashboard {
    public loggedIdentity?: LoggedIdentity;
    public embedded?: Embedded;
    //public sections?: Section[];
    public forbidden?: Forbidden;
    public universe?: UniverseEnum;
}
